
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.846 2.75a1.096 1.096 0 100 2.192 1.096 1.096 0 000-2.192zM1.25 3.846a2.596 2.596 0 015.082-.75H18a.75.75 0 010 1.5H6.332a2.597 2.597 0 01-5.082-.75zm7.654 6.152a1.096 1.096 0 110 .004v-.004zM10 12.596a2.597 2.597 0 01-2.486-1.846H2a.75.75 0 010-1.5h5.514a2.597 2.597 0 014.972 0H18a.75.75 0 010 1.5h-5.514A2.597 2.597 0 0110 12.596zm3.668 2.808H2a.75.75 0 000 1.5h11.668a2.597 2.597 0 100-1.5zm1.39.746a1.096 1.096 0 110 .007v-.003-.004z","fill":"currentColor"}})])
          )
        }
      }
    